import store from "@/store";

export const getHeaders = () => {
  return {
    widgetId: store.state.widgetId,
    accountId: store.state.amoAccountId,
  };
};

export const apiCoreInterceptor = (config) => {
  const { headers } = config;
  const { accountId } = getHeaders();
  headers["X-Widget-Id"] = 134;
  headers["X-Account-Id"] = accountId;
  headers["X-Api-Token"] = "55336a90-da6c-48cf-af7b-8ad2d51958a5";
  headers["X-Custom-Integration"] = 1;

  return config;
};
